"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.START_SPEAKING_ACTIVITY = void 0;
exports["default"] = startSpeakingActivity;
var START_SPEAKING_ACTIVITY = 'WEB_CHAT/START_SPEAKING';
exports.START_SPEAKING_ACTIVITY = START_SPEAKING_ACTIVITY;
function startSpeakingActivity() {
  return {
    type: START_SPEAKING_ACTIVITY
  };
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJuYW1lcyI6WyJTVEFSVF9TUEVBS0lOR19BQ1RJVklUWSIsImV4cG9ydHMiLCJzdGFydFNwZWFraW5nQWN0aXZpdHkiLCJ0eXBlIl0sInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXMiOlsiLi4vLi4vc3JjL2FjdGlvbnMvc3RhcnRTcGVha2luZ0FjdGl2aXR5LmpzIl0sInNvdXJjZXNDb250ZW50IjpbImNvbnN0IFNUQVJUX1NQRUFLSU5HX0FDVElWSVRZID0gJ1dFQl9DSEFUL1NUQVJUX1NQRUFLSU5HJztcblxuZXhwb3J0IGRlZmF1bHQgZnVuY3Rpb24gc3RhcnRTcGVha2luZ0FjdGl2aXR5KCkge1xuICByZXR1cm4ge1xuICAgIHR5cGU6IFNUQVJUX1NQRUFLSU5HX0FDVElWSVRZXG4gIH07XG59XG5cbmV4cG9ydCB7IFNUQVJUX1NQRUFLSU5HX0FDVElWSVRZIH07XG4iXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQSxJQUFNQSx1QkFBdUIsR0FBRyx5QkFBeUI7QUFBQ0MsT0FBQSxDQUFBRCx1QkFBQSxHQUFBQSx1QkFBQTtBQUUzQyxTQUFTRSxxQkFBcUJBLENBQUEsRUFBRztFQUM5QyxPQUFPO0lBQ0xDLElBQUksRUFBRUg7RUFDUixDQUFDO0FBQ0gifQ==